/*! Backbone.Rpc - v0.1.1
------------------------------
Build @ 2012-11-15
Documentation and Full License Available at:
http://asciidisco.github.com/Backbone.Rpc/index.html
git://github.com/asciidisco/Backbone.Rpc.git
Copyright (c) 2012 Sebastian Golasch <public@asciidisco.com>

Permission is hereby granted, free of charge, to any person obtaining a
copy of this software and associated documentation files (the "Software"),
to deal in the Software without restriction, including without limitation
the rights to use, copy, modify, merge, publish, distribute, sublicense,
and/or sell copies of the Software, and to permit persons to whom the
Software is furnished to do so, subject to the following conditions:
The above copyright notice and this permission notice shall be included in
all copies or substantial portions of the Software.

THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND,
EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE,
ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS
IN THE SOFTWARE.*/

//////////////////////////////////////////////////////////////
// BEGIN Module inclusion pattern for Node, AMD or globals: //
//////////////////////////////////////////////////////////////
(function(root, define, require, exports, module, factory, undef) {
	'use strict';
	if (typeof exports === 'object') {
		// Node. Does not work with strict CommonJS, but
		// only CommonJS-like enviroments that support module.exports,
		// like Node.
		module.exports = factory(
			require('underscore'),
			require('backbone'),
			require('jquery'),
		);
	} else if (typeof define === 'function' && define.amd) {
		// AMD. Register as an anonymous module.
		define(['underscore', 'backbone', 'jquery'], function(_, Backbone, $) {
			// Check if
			_ = _ === undef ? root._ : _;
			Backbone = Backbone === undef ? root.Backbone : Backbone;
			$ = $ === undef ? root.$ : $;
			return (root.Backbone = factory(_, Backbone, $));
		});
	} else {
		// Browser globals
		root.returnExportsGlobal = factory(root._, root.Backbone, root.$);
	}
})(this, this.define, this.require, this.exports, this.module, function(
	_,
	Backbone,
	$,
	undef,
) {
	////////////////////////////////////////////////////////////
	// END Module inclusion pattern for Node, AMD or globals: //
	////////////////////////////////////////////////////////////

	// Backbone.Rpc
	// Plugin for using the backbone js library with a remote json-rpc handler
	// instead of the default REST one
	//
	// Heavily modified by NetXposure.
	//
	// FYI when debugging:
	// The code path when firing a query is: sync() -> checkMethods() -> triggerQuery() -> _query() -> $.ajax(args, callback ...)
	// The code path when receiving a bad result is: callback() -> parseReply() -> onError -> (handleException, sync.error(), promise.reject)
	// The code path when receiving a good result is: callback() -> parseReply() -> (method parser) -> (sync.success(), promise.resolve)
	//

	'use strict';

	_ = _ || window._;
	$ = $ || window.$;
	Backbone = Backbone || window.Backbone;

	var Rpc = function(options) {
			// merge the users options
			this.options = options = options || {};

			this.garbageCollect = () => {
				this.garbageCollected = true;
				this.callsByName && Object.entries(this.callsByName, ([key, value]) => {
					console.warn(`aborting calls: ${key}`);
					const xhr = value && value.xhr;
					if (xhr && xhr.state && xhr.state() === 'pending') {
						xhr.abort && xhr.abort();
					}
				});
			};

			// check if we have a non std. namespace delimter
			this.namespaceDelimiter =
				options.namespaceDelimiter || this.namespaceDelimiter;
			// check if we have a non std. content-type
			this.contentType = options.contentType || this.contentType;
			// check for duplicate query policy
			this.duplicateQueryPolicy =
				options.duplicateQueryPolicy || this.duplicateQueryPolicy;
			// fix issue with the loss of this
			_.bindAll(
				this,
				'onError',
				'_query',
				'query',
				'checkMethods',
				'handleExceptions',
			);
		},
		// store the old Backbone.Model & Collection constructors
		oldModelConst = Backbone.Model.prototype.constructor,
		oldCollectionConst = Backbone.Collection.prototype.constructor,
		// wrap the new constructor around Backbone's old ones:
		newConst = function(model, my_ctxt) {
			// check if the model has the rpc property and methods defined
			if (my_ctxt.rpc && my_ctxt.methods) {
				// walk through the methods, attaching rpc functions for anything other than the CRUD set supported by Backbone.sync:
				_.each(
					my_ctxt.methods,
					_.bind(function(method, signature) {
						if (
							(!_.contains[('create', 'read', 'update', 'remove')], signature)
						) {
							// This is the part that binds the non-CRUD rpc methods to model/collection methods:
							// generate the method for the signature
							my_ctxt[signature] = _.bind(function() {
								// DAM-8468: method definition functions should receive arguments and options
								//
								// Allowing backbone RPC methods to take arguments is tricky, because
								// execution passes through backbone.sync, which has a very specific signature.
								// So we try to detect the situations where other arguments are expected by method signature functions,
								// and pull them from the arguments object as neeed.
								//
								// To get this right we need the method signature functions to define the number of arguments
								// they're expecting, including a final options argument.  If the method signature defines other
								// expected arguments but does *not* include an options argument, this algorithm breaks.
								// Therefore: methods functions that define any other arguments MUST ALSO DEFINE AN OPTIONS ARGUMENT.
								// That's not ideal, but it's manageable.  I don't yet know a better way. -m-

								var options;

								// JS stores the number of args in a function definition as the function's .length property:
								var argsExpected = _.isFunction(this.methods[signature])
									? this.methods[signature].length
									: 0;
								if (argsExpected == 0) {
									// It's also possible that the method signature is a plain array but one of its elements is a function ....
									_.each(this.methods[signature], function(param) {
										if (_.isFunction(param)) {
											// If that's the case, they had better all expect the same arguments, or there'll be hell to pay ....
											// (Not even going to test for that.  Just do it right.)
											argsExpected = param.length;
										}
									});
								}

								if (argsExpected == 0) {
									// nothing mentions in the method function, but standard backbone/bRPC args could still have been passed.
									options = arguments[0]; // maybe undefined
								} else {
									// Get the options object from the defined position (must always be the last argument expected)
									options = arguments[argsExpected - 1]; // maybe undefined
								}

								if (argsExpected > 1) {
									// args other than 'opts' are also expected
									options = options || {};
									// Preserve the args as an option.
									options.invokedArguments = [];
									argsExpected--; // don't include the options argument
									for (var i = 0; i < argsExpected; i++) {
										options.invokedArguments[i] = arguments[i];
									}
								}

								var defaultExceptionHandler = this.defaultExceptionHandler;
								// invoke the dynamicly created method
								return Backbone.sync(
									signature,
									my_ctxt,
									_.extend(
										{},
										{
											// If options.error isn't set, set it to our default exception handler:
											error: defaultExceptionHandler
												? function(model, error) {
														defaultExceptionHandler(error);
												  }
												: undefined,
										},
										options,
									),
								);
							}, my_ctxt);
						}
					}, my_ctxt),
				);
			}
		},
		// store the old Backbone.sync method for later use
		oldSync = Backbone.sync;

	/////////////////
	// Custom RPC errors we can throw:
	/////////////////
	_.extend(Rpc, {
		/**
		 * A generic JSON-RPC error: adds 'code' and 'data' to the JS Error object.
		 */
		RpcError: function(code, message, data) {
			var me = new Error(message || 'JSON-RPC error');
			me.code = code || 0;
			me.message = message || 'JSON-RPC error';
			me.data = data;
			return me;
		},

		/***
		 * The parser for an object's backbone.rpc method can decide that the
		 * DAM sent invalid data and throw this error in order to tell X7 that
		 * the result should be considered an error.  Sometimes we get errors
		 * encoded in success handlers ...
		 */
		ParseError: function(message, data) {
			return new Rpc.RpcError(
				-101,
				message || 'invalid data in JSON RPC response',
				data,
			);
		},

		/***
		 * The DAM sometimes provides responses that are not JSON-RPC compliant.
		 * Backbone.RPC defines several codes for specific problems; our generic problem code will be -102
		 */
		ProtocolError: function(message, data) {
			return new Rpc.RpcError(
				-102,
				message || 'invalid data in JSON RPC response',
				data,
			);
		},

		/***
		 * If JSON-RPC reports an error, we can throw one of these:
		 */
		MethodError: function(code, message, data) {
			return new Rpc.RpcError(code, message, data);
		},

		/***
		 * In the case where we get a bad ValidationBean back from the server, the
		 * server is sending error as success again.  A special error for that case:
		 */
		ServerValidationError: function(message, data) {
			return new Rpc.RpcError(-103, message, data);
		},

		/***
		 * HTTP Transport errors:
		 */
		Http404Error: function(message, data) {
			return new Rpc.RpcError(-1, message || '404', data);
		},

		Http500Error: function(message, data) {
			return new Rpc.RpcError(-2, message || '500', data);
		},

		/**
		 * Syntax/misc errors in the model definition of the RPC methods/parsers data
		 */
		DefinitionError: function(message, data) {
			return new Rpc.RpcError(-3, message || 'Type mismatch', data);
		},
	});

	// http://stackoverflow.com/questions/783818/how-do-i-create-a-custom-error-in-javascript
	Rpc.RpcError.prototype = Rpc.MethodError.prototype = Rpc.ProtocolError.prototype = Rpc.ParseError.prototype = Rpc.ServerValidationError.prototype = Rpc.Http404Error.prototype = Rpc.Http500Error.prototype = Rpc.DefinitionError.prototype =
		Error.prototype;

	// TODO: Document
	Rpc.prototype = {
		// User defined options placeholder
		options: {},

		// Default charset
		charset: 'iso-8859-1',

		// Default namespace
		namespace: '',

		// Default namespace delimiter
		//namespaceDelimiter: '/',
		// For Netx:
		namespaceDelimiter: '',

		// Default content type
		contentType: 'application/json',

		// User set url placeholder
		url: '',//Netx.URL.api, // FYI this doesn't work if Netx.URL isn't set yet, as happens in develop (lately).  (Causes DAM-9677, as addressed in netx.js)

		/**
		 * By default, if an RPC method is called multiple times in quick succession, each query eventually
		 * returns its success or failure.  But there are situations in which we want each new call of a method
		 * to abort any currently-pending call to that method.
		 *
		 * When calling Netx RPC methods, you can provide the option duplicateQueryPolicy = "abort" to
		 * obtain this behavior.  Aborted requests neither succeed nor fail, and their promises never
		 * resolve.
		 *
		 * Or, you can provide a policy of 'merge', to prevent the second query & return the promise
		 * of the first one.  Both queries will receive the same response, at the same time (or rather, in immediate successive threads.)
		 *
		 * The default policy of 'ignore' changes nothing, which means both queries are processed -- in unknown order.
		 *
		 * An entire RPC instance can be assigned this behavior for all method calls by providing that same option to its constructor.
		 */
		duplicateQueryPolicy: 'ignore', // standard do-nothing policy == we send two queries.

		newConst: newConst,

		/**
		 * parseReply() looks at the response from a succesful RPC call.  It detects
		 * errors & bad JSON-RPC behavior.  If it all looks good, it invokes the
		 * parser for the method (if any), and detects errors from that.  If this
		 * method detects no error then the RPC call is successful.
		 */

		parseReply: function(reply, status, fn, id) {
			if (this.garbageCollected) return;

			// DAM-3261 dispatch to app:server:error to reset the count of errors
			dispatcher.trigger('app:server:success');

			var replyParsed = false;

			try {
				// Occasionally we are seeing the call being declared as undefined
				// which causes call.deferred to fail
				var call = this.callsById[id];
				var d = call.deferred;
				// So many ways JSON-RPC can go wrong ....

				// If the reply is empty (null, undefined or empty string), that's a bogus response.
				if (_.isUndefined(reply) || _.isNull(reply)) {
					throw new Rpc.ProtocolError(
						'"' + fn + '": Null reply from server (no reply)',
						{reply: reply, status: status, call: call},
					);
				} else if (!_.isObject(reply)) {
					throw new Rpc.ProtocolError(
						'"' + fn + '": bad reply from server (no an object)',
						{reply: reply, status: status, call: call},
					);
				}

				// If the ID field doesn't match our id, something is way bogus:
				else if (_.isUndefined(reply.id) || reply.id !== id) {
					throw new Rpc.ProtocolError('"' + fn + '": bad request ID', {
						reply: reply,
						status: status,
						call: call,
					});
				}

				// If the reply doesn't have either a .result or an .error property, that's bogus JSON-RPC.
				else if (
					!_.isObject(reply) ||
					(_.isUndefined(reply.result) && _.isUndefined(reply.error))
				) {
					throw new Rpc.ProtocolError(
						'"' + fn + '": Garbled JSON from server',
						{reply: reply, status: status, call: call},
					);
				}

				// If the reply has a .error property that's not an object, that's also bogus JSON-RPC. Trigger an error.
				else if (!_.isUndefined(reply.error) && !_.isObject(reply.error)) {
					throw new Rpc.ProtocolError(
						'"' + fn + '": Garbled JSON from server',
						{reply: reply, status: status, call: call},
					);
				}

				// If the reply does have a .error property, then JSON-RPC is reporting a server error, which we pass along.
				else if (reply.error) {
					throw new Rpc.MethodError(
						reply.error.code,
						'"' + fn + '": error: ' + reply.error.message,
						{reply: reply, status: status, call: call},
					);
				}

				// Vestigial residue of the DAM's former error handling system:
				// If we see a validationData object in the result, check for a failed ValidationBean: an error disguised as success.
				else if (
					reply.result &&
					reply.result.validationData &&
					reply.result.validationData.length &&
					(reply.result.status < 0 ||
						reply.result.validationData[0].label == 'Error')
				) {
					console.warn('Server sent error as success!');

					// reconfigure the data object to look like proper JSON/RPC error return: http://www.jsonrpc.org/specification#response_object
					reply.error = {
						code: -32099, // Let's call this a "Server Validation Error"
						message:
							'Server Validation Error: ' +
							reply.result.validationData[0].value, // TODO: parse the whole array of N validation beans.
						reply: reply.result.validationData,
					};

					delete reply.result;

					throw new Rpc.ServerValidationError(
						'"' + fn + '": error: ' + reply.error.message,
						{reply: reply, status: status, call: call},
					);
				}

				// Anything else is a valid result, we hope.
				else {
					var result;
					if (
						// asset collections now have pager models
						call.rpcMethod !== 'facetedSearch' &&
						call.rpcMethod !== 'searchAssetsByAttributeHistory' &&
						call.model &&
						call.model.isCollection &&
						(call.model.pager && call.model.pager.constructor.__name__ === 'Pager') &&
						_.isObject(reply.result) &&
						_.size(reply.result) >= 2 &&
						(_.isArray(reply.result.results) || _.isArray(reply.result.items)) &&
						(_.isNumeric(reply.result.size) || _.isNumeric(reply.result.totalItems))
					) {
						// We have detected a paged reply, and a collection with paging
						// For paged replies, the API returns an object containg both a page
						// of results and a total item count: { results: [], size: 0 }
						// The total item count should be set on the collection's pager object:
						// console.debug('updating pager with paged result count');
						call.model.pager.set('itemTotal', reply.result.size || reply.result.totalItems || 0);
						if (reply.result.startIndex != null) {
							call.model.pager.setStartIndex(reply.result.startIndex);
						}
						// The rest can be passed on:
						result = reply.result.results || reply.result.items;
					} else {
						// A normal, unpaged reply
						result = reply.result;
					}

					// Things to warn about that aren't necessarily wrong:
					// If the reply has a .result property that's null or undefined, that's maybe legit JSON-RPC but not how we want things to work; emit a warning.
					if (_.isNull(result) || _.isUndefined(result)) {
						// For now, just emit a warning and move on:
						// (The rpc method parser can still throw an exception if a null result is truly problematic.)
						console.warn(
							'API error: RPC method "' + fn + '" returned null result',
						); // we should file bugs on these.
						//console.warn(call.stack);
					}

					if (call.model) {
						// Convert 'goo' attributes, if defined
						if (call.model.gooAttrs) {
							result = call.model.unpackAttrs(result);
						}
						// invoke method parser, if defined
						if (
							call.model.parsers &&
							_.isFunction(call.model.parsers[call.method])
						) {
							var parsed = call.model.parsers[call.method].apply(
								call.model,
								[result].concat(this.decodeArguments(call.options)),
							);
							if (!_.isUndefined(parsed)) {
								// allow the parser to change the result, unless it returned undef.
								result = parsed;
							}
						}
					}
					// All done.
					replyParsed = true;
				}
			} catch (e) {
				this.onError(e, call, reply, status);
			}

			// DEVNOTE: we must do these next things outside of the try/catch loop, so
			// that future exceptions are not caught.  That's why we set/check this replyParsed flag.
			if (replyParsed) {
				// All done!
				// TODO: corrall all the various calls to unregisterCall() ... ideally we'd only call it in one place.
				// (How critical is the timing, really?)
				this.unregisterCall(call);

				// Every succesful sync resets the server's logout timer; reset our client one too:
				if (Netx && Netx.session) {
					Netx.session.resetLogoutTimer(); // every succesful sync resets the server's logout timer; reset our client one too.
				}

				// If this is a backbone sync method, here is where Backbone picks up the changes:
				if (_.isFunction(call.options.success)) {
					call.options.success(result);
				}

				// Resolve the promise:
				d.resolveWith(call.model ? call.model : this, [result]);
			}
		},

		// Handle the fallout from a JSON-RPC error or exception:
		// find the right error params to call the error handler (if any),
		// then reject the promise, or call the exceptionHandler if there are no reject handlers on the promise.
		onError: function(error, call, reply, status) {
			if (!(error instanceof Error)) {
				// If the "error" argument is the string "abort" something
				// has triggered our duplicateQueryPolicy and we need to break out of the error method.
				if (error === 'abort') {
					console.warn(
						'Call: %s, aborted by duplicateQueryPolicy',
						call.method,
					);
					this.unregisterCall(call);
					return;
				} else {
					// this should not happen, period.

					// except it does happen any time the dam is unresponsive, no error is passed back
					console.warn('rpc.onError called with non-error!');
					// DAM-3261 dispatch to app:server:error to count the errors
					dispatcher.trigger('app:server:error');
				}
			}

			// Hang on to some knowledge if possible, while trying to absorb the contents of a JSON-RPC error object into a JS Error object.
			// TODO: do this somewhere higher up the tree maybe?
			error.data = error.data || {};
			error.data.call = error.data.call || call;
			error.data.reply = error.data.reply || reply;
			if (!error.code && reply.code) {
				error.code = reply.code;
			}

			// If we came here from the error handler of the ajax call, then 'reply' is an jqXHR object.
			if (reply instanceof XMLHttpRequest) {
				if (status == 'abort') {
					// We aborted a request.  Call no handlers or anything.  Just clean up.
					this.unregisterCall(call);
					return this;
				} else {
					// TODO: this won't be a 500 ... maybe we need a generic HTTP error that includes the code somewhere?
					//this.handleExceptions(new Rpc.Http500Error(reply.status));
					error = new Rpc.Http500Error(reply.status);
				}
			}

			// If the sync() call defined an error callback, call it.
			// NOTE: this callback calls Backbone's callback, triggering 'error' on the object, unless overridden
			// with the 'error' option to a sync method.
			// We have moved away from that pattern in X7, and prefer to use promises.

			if (call && call.options && _.isFunction(call.options.error)) {
				// TODO: return error instead of reply.error ?  Not sure where this is being parsed.
				call.options.error.apply(this, [reply.error]);
			} else {
				console.warn('Error in unknown service method. Call is undefined.');
			}

			// if there are no reject handlers on the deferred, we should always call the exception handler.
			// This sometimes throws errors after updating the DAM and trying to log back in - `deferred of undefined`
			if (call) {
				call.deferred.rejectWith(call.model ? call.model : this, [
					error,
					status,
					call.xhr,
				]);
			}

			// TODO: why not just throw this error, causing an exception, and allow it to be
			// handled by an exception-handling mechanism?  Why reinvent the wheel with handleExceptions()?
			// (vanilla bRPC came with weird error-munging that never made sense to me ...)
			this.handleExceptions(error);

			// }
		},

		//////////////////////////////////////////////////////////////////////////////////
		// Perform a query, sandwiched between a request:* event and a complete:* event .
		//
		triggerQuery: function(method, exec, parsedParameters, options, model) {
			// DEVNOTE:
			// For models & collections, Backbone 1.1.2 'request' events include a jqXHR object
			// from which one can probably deduce the method name.
			// But this 'request:*' event is nicer for most of our needs,
			// and because we use a colon & they don't, there's no conflict.
			// (We added this when we were still using Backbone v1.1.1 .)

			// Trigger request:* event as the call goes out:
			model.trigger('request:' + method, model, undefined, options);

			// Make the call:
			var p = this._query(method, exec, parsedParameters, options, model);

			// Trigger complete:* event when the call finishes:
			p.then(function(result) {
				if (!(options && options.silent)) {
					model.trigger(
						'complete:' + method,
						model,
						result,
						_.omit(options, 'invokedArguments'),
					);
				}
			});

			return p;
		},

		//////////////////////////////////////////////////////////////
		// Our public query method: query()
		//
		// Backwards compatability fix: a recent refactor changed the signature of .query(),
		// which is supposed to be an internal method to this file.  However, it turns
		// out that various other parts of Netx/X7 have been reaching in here and calling
		// Netx.Rpc.query() directly.  So here is a public .query() method which translates the former
		// method signature into the signature of our internal method, now renamed ._query() .
		//
		query: function(fn, params, callback) {
			return this._query(fn, fn, params).then(callback);
		},

		//////////////////////////////////////////////////////////////
		// Our internal query method: _query()
		//
		// This manages the call-tracking bureaucracy (registerCall/unregisterCall) for this request,
		// and then -- if the call is not already a wrapped call --  builds & executes an AJAX query .
		//
		_query: function(method, fn, params, options, model) {
			options = options || {};
			options.duplicateQueryPolicy =
				options.duplicateQueryPolicy || this.duplicateQueryPolicy;

			// Keep track of in-progress RPC calls & all their state:
			this.callsById = this.callsById || {};
			this.callsByName = this.callsByName || {};

			// Is this meant to be a normal AJAX query, or did a method function return a promise that we're just wrapping?
			var isAjax = !_.isPromise(fn);

			// This is what _query now returns, instead of the raw promise from $.ajax:
			var d = isAjax ? new $.Deferred() : fn;

			// generate unique request id (timestamp)
			var id = _.uniqueId(String(new Date().getTime()));

			// Create a record describing this API call:
			var call = {
				id: id,
				deferred: d,
				model: model,
				method: method, // the key of the call in model.methods & model.parsers
				params: params,
				rpcMethod: isAjax ? fn : method + ':promise', // the name of the API function on the DAM
				options: options,
			};

			// Grab the stack:
			try {
				throw new Error('API call from:');
			} catch (e) {
				call.stack = e.stack;
			}

			// Enforce duplicate query policy if there's a duplicate:
			if (
				options.duplicateQueryPolicy !== 'ignore' &&
				this.callsByName[call.rpcMethod]
			) {
				switch (options.duplicateQueryPolicy) {
					case 'abort':
						var otherXhr =
							this.callsByName[call.rpcMethod] &&
							this.callsByName[call.rpcMethod].xhr;
						// Is there another pending call to abort?
						if (otherXhr && otherXhr.state && otherXhr.state() == 'pending') {
							otherXhr.abort && otherXhr.abort();
						}
						break;
					case 'merge':
						// Hand back the previous query's promise
						return this.callsByName[call.rpcMethod].deferred.promise();
						break;
				}
			}

			if (isAjax) {
				// check if params and the function name are ok.
				if (!_.isArray(params) || !_.isString(fn)) {
					// TODO: again, why not just throw errors?  why 'onError' them?
					return this.onError(
						new Rpc.DefinitionError(
							'Type Mismatch in RPC function definition for "' +
								call.method +
								'"',
						),
						call,
						params,
					);
				} else {
					// DAM-6494: prepend session key to parameters list for all non-public API calls:
					if (Netx && Netx.session) {
						if ((Netx.session.get('publicMethods') || []).indexOf(fn) == -1) {
							var authParam = Netx.session.getToken() || Netx.session.getKey();
							if (authParam) {
								// ... prepend the session key to the parameters
								params.unshift(authParam);
								// console.log('added key to method call'); //DEBUG
							} else {
								// There would be no access key for the public method `getPublicMethods`
								if (fn !== 'getPublicMethods') {
									console.warn('no access key for private method "' + fn + '"');
								}
							}
						}
					}
				}

				////////////////////////////////////////
				// XHR PROGRESS TRACKING
				////////////////////////////////////////
				var xhrCompletedProgress = false,
					trackProgress = false;

				// REST progress/messaging
				var _xhrComplete = function() {
					if (!model || !trackProgress) return;
					xhrCompletedProgress = true;
					dispatcher.trigger('netx:rest:loaded', model, this.namespace, fn);
				}.bind(this);

				if (model && model.xhrTrackProgress) {
					var xhrExcludeProgress = model.xhrExcludeProgress || [];
					if (xhrExcludeProgress.indexOf(fn) < 0) {
						var xhrTrackProgress = model.xhrTrackProgress;
						xhrTrackProgress =
							xhrTrackProgress === true || xhrTrackProgress[fn];

						trackProgress =
							xhrTrackProgress != null &&
							(xhrTrackProgress === true || xhrTrackProgress.call(model));

						trackProgress &&
							_.delay(
								function() {
									!xhrCompletedProgress &&
										dispatcher.trigger(
											'netx:rest:loading',
											model,
											this.namespace,
											fn,
										);
								}.bind(this),
								15,
							);
					}
				}
				////////////////////////////////////////
				// !XHR PROGRESS TRACKING
				////////////////////////////////////////

				// create Ajax query:
				var ajaxArgs = {
					contentType: this.contentType + '; charset=' + this.charset,
					type: 'POST',
					dataType: 'json',
					url: (this.url || Netx.URL.api) + '/' + fn,
					data: JSON.stringify({
						dataContext: 'json',
						jsonrpc: '2.0',
						method: this.namespace + this.namespaceDelimiter + fn,
						id: id,
						params: params,
					}),
					statusCode: {
						// Convert errorThrown to special HTTP errors ... why?
						404: _.bind(function(jXhr, status, errorThrown) {
							_xhrComplete();
							this.onError(
								new Rpc.Http404Error(errorThrown.message),
								call,
								jXhr,
								status,
							);
						}, this),
						500: _.bind(function(jXhr, status, errorThrown) {
							_xhrComplete();
							this.onError(
								new Rpc.Http500Error(errorThrown.message),
								call,
								jXhr,
								status,
							);
						}, this),
					},
					success: _.bind(function(data, status, xhr) {
						if (this.garbageCollected) return;
						_xhrComplete();
						this.parseReply(data, status, fn, id);
					}, this),
					error: _.bind(function(jXhr, status, errorThrown) {
						if (this.garbageCollected) return;
						_xhrComplete();
						// these two error types are handled by statusCode, above...
						if (jXhr.status !== 404 && jXhr.status !== 500) {
							// for all other errors, jump to the error handler
							this.onError(errorThrown, call, jXhr, status);
						}
					}, this),
					headers: options.headers,
				};

				// @if NODE_ENV="development"
				////////////////////////////////

				// TODO: push this logic into jQuery, using sinon.js.
				//
				// If this object has a test fixture for this method, return the test data directly & don't bother the server

				if (model && model.fixtures && model.fixtures[fn]) {
					var data = {
						id: id,
						result: model.fixtures[fn].valid,
					};
					if (_.isString(data.result)) {
						data.result = JSON.parse(data.result);
					} else if (_.isFunction(data.result)) {
						data.result = data.result.apply(model, params);
					}
					// call.xhr = {};  // TODO: a more convincing fake XHR object?
					_.defer(
						_.bind(function() {
							this.parseReply(data, 200, fn, id);
						}, this),
					);
					console.debug('faking server response for method "' + fn + '"');
				} else {
					// send the real query:

					///////////////////////////////
					// @endif

					call.xhr = $.ajax(ajaxArgs);

					// @if NODE_ENV="development"
					///////////////////////////////
				}
				///////////////////////////////
				// @endif
			} else {
				// We are wrapping a promise
				// Just in case it was an ajax promise, and .xhr is defined:
				call.xhr = d.xhr;

				d.then(
					_.bind(function(result) {
						// Clean up the call record when we're done,
						// since parseReply won't ever be called.
						this.unregisterCall(call);

						if (this.garbageCollected) return;

						// Call the success method if defined,
						if (call.options.success) {
							call.options.success(result);
						}
					}, this),
					// on reject, call the error method if defined:
					call.options.error,
				);
			}

			// Store our record of the call:
			this.registerCall(call);

			return isAjax ? d.promise() : d;
		},

		// registerCall() keeps track of an API call in progress, in the hashes this.callsByName and this.callsById.
		// It also sets .syncing on the call's model, to indicate that the model has unresolved API calls in progress.
		//
		// unregisterCall() clears tracking of a call, and removes .syncing from the model if it has no more API calls in progress.

		registerCall: function(call) {
			this.callsByName[call.rpcMethod] = this.callsById[call.id] = call;
			if (call.model) {
				call.model.syncing = true;
			}
		},

		unregisterCall: function(call) {
			delete this.callsById[call.id];
			delete this.callsByName[call.rpcMethod];
			if (call.model) {
				// If there are no more calls, deleting the 'syncing' flag:
				if (!(_.size(this.callsById) || _.size(this.callsByName))) {
					delete call.model.syncing;
				}
			}
		},

		/**
		 * checkParameters
		 * Check the parameters of a method definition
		 *
		 * @param {Netx.Model} model model
		 * @param {Array} params Parameters of a method definition
		 * @param {Object} options RPC options
		 * @param {boolean} wasFunction Was this parameter generated by a function?  Those are parsed differently ...
		 * @returns {Object} The parsed value
		 * @see checkParameter
		 */
		checkParameters: function(model, params, options, wasFunction) {
			var parsedParams = [];

			_.each(
				params,
				function(param) {
					parsedParams.push(
						this.checkParameter(model, param, options, wasFunction),
					);
				},
				this,
			);

			return parsedParams;
		},

		/**
		 * checkParameter
		 * Check one parameter of a method definition
		 *
		 * @param {Netx.Model} model model
		 * @param {} param Parameter of a method definition
		 * @param {} options RPC options
		 * @param {boolean} wasFunction Was this parameter generated by a function?  Those are parsed differently ...
		 * @returns {Object} The parsed value
		 */
		checkParameter: function(model, param, options, wasFunction) {
			options = options || {};

			// is the param a function?
			if (_.isFunction(param)) {
				var result = param.apply(model, this.decodeArguments(options));
				if (_.isFunction(result)) {
					throw new Rpc.DefinitionError(
						'rpc method parameter functions cannot return other functions',
						item,
					);
				} else if (_.isUndefined(result)) {
					throw new Rpc.DefinitionError(
						'rpc method parameter functions cannot return undefined parameters',
						item,
					);
				} else {
					return result;
				}
			}

			if (param.isModel || param.isCollection) {
				return param.toJSON();
			}

			if (_.isObject(param)) return param;

			if (_.isNumber(param)) return param;

			if (_.isBoolean(param)) return param;

			if (_.isUndefined(param)) {
				throw new Rpc.DefinitionError(
					'rpc method parameters cannot be undefined',
					item,
				);
			}

			if (_.isNull(param)) {
				// We dislike using NULL in X7. Backbone doesn't play well with NULL.  We prefer to pass
				// empty strings in json-rpc calls.  But during development we have sometimes found API
				// calls that require a null, and until those get fixed we have to allow NULLs.
				console.warn('passing a NULL rpc parameter!');
				return param;
			}

			if (!_.isString(param)) {
				// Programmer Hat-Eat Error:
				// Somebody defined a seventh fundamental data type in Javascript without consulting the ECMA standards committee!
				// Night is day, dogs are cats, society has collapsed, all bets are off, anything could happen.
				// Loot some RMEs, retreat to your safe room & await further instructions.
				throw new Rpc.DefinitionError('Unknown parameter data type!');
			}

			// From here on can safely assume param is a string.
			if (param == '') {
				return param; // totally valid to specify empty strings as API args.
			}

			if (param == 'attributes') {
				console.warn("'attributes' rpc argument removed in 8.12");
				// ... but you can still pass a string called "attributes".  It just doesn't get any special treatment.
			}

			// Encode 'goo' attributes if there are some and 'goo' is specified.
			if (param == 'goo' && model.attributes && model.gooAttrs) {
				return JSON.stringify(_.pick(model.attributes, model.gooAttrs));
			}

			// If this parameter was returned by a function, we're done with it.
			if (wasFunction) {
				return param;
			}

			// If the parameter was defined in an array,
			// try to use it as a reference on the model/collection,
			// ala vanilla Backbone.RPC :
			if (param.indexOf('.') < 0) {
				// nothing special here.
				if (model.isModel) {
					//if (model.has(param))
					// HACK: Backbone (darn it!) returns false if a property exists but is null ....
					if (typeof model.attributes[param] !== 'undefined') {
						// String refers to a model attribute.  Return the attribute.
						return model.get(param);
					}
				}

				// if the key can't be found in the attributes, it may just be a JS object property
				if (!_.isUndefined(model[param])) {
					// String refers to a model property. Return the property.
					// TODO: now that we have method arguments, maybe deprecate this feature?
					return model[param];
				} else {
					throw new Rpc.DefinitionError(
						'rpc method parameter "' + param + '" is undefined',
					);
				}
			} else {
				// Parameters containing dots: recurse into objects.
				console.warn(
					'dot-notation in method arguments deprecated, gone in 8.13',
				);

				var parts = param.split('.');
				//console.debug("split ", param, ' into ', parts.join(','));
				if (typeof model[parts[0]] !== 'undefined') {
					// extract the child property from the parent property
					return model[parts[0]][parts[1]];
				} else if (model.isModel && model.has(parts[0])) {
					// extract the child property from the attribute
					return model.get(parts[0])[parts[1]];
				} else {
					// parent property doesn't exist
					//console.debug('bonk');
					return undefined;
				}
			}
		}, // checkParameter

		/**
		 * When method definitions, method parameter definitions or method parsers are functions,
		 * they are invoked with the original arguments + an enhanced options object. (DAM-8469/DAM-8468)
		 * We encode the original arguments in the options object, and decode them here:
		 * @param {object} options - Sync options
		 * @returns {array} Arguments array.  Last argument *must* be an options object.
		 */
		decodeArguments: function(options) {
			if (options.invokedArguments) {
				// arguments were encoded.  Use them.
				return options.invokedArguments.concat(
					_.omit(options, 'invokedArguments'),
				);
			} else {
				// The default case with no arguments:
				return [options];
			}
		},

		// checkMethods() parses the model.methods array to create the RPC signature, then calls _query().
		checkMethods: function(model, method, options) {
			//if (this === window) debugger; // DEBUG

			var definition = null,
				deeperNested = false,
				exec = null,
				parsedParameters = [],
				wasFunction = false,
				hadArguments = false,
				functionArgs = 0;

			options = options || {};

			// Rewrite method if name is delete
			// NOTE: this is pretty screwy: you must name your delete method "remove" in your model.
			// but you must call the model's "delete" method to execute it.
			method = method === 'delete' ? 'remove' : method;

			// This can only be an array or a function:
			definition = model.methods[method];
			// If function, replace with return value (which must be an array)
			if (_.isFunction(definition)) {
				wasFunction = true;
				hadArguments = definition.length > 0;

				// Decode any encoded arguments into an array:
				//
				var decodedArguments = this.decodeArguments(options);

				// DAM-9216: (bug with multi-call methods and success/error)
				//
				// If this method function wraps any other inner RPC methods, then it should,
				// and probably does, pass along its options argument when calling those inner methods.
				// However, if options.success or options.error are defined, they're intended
				// to reflect the status of this outer method, not of any inner ones.
				// Therefore, we must omit those two options when calling this method function,
				// so they don't get passed to other RPC functions & cause backbone.sync
				// (or whatever) to finish prematurely.
				//
				// Assertion:
				// For the next bit, we depend on decodedArguments() always returning an array,
				// always having at least one element in the array,
				// and the last element always being an options argument.
				if (
					decodedArguments.length == 0 ||
					_.isString(_.last(decodedArguments)) ||
					_.isNumber(_.last(decodedArguments)) ||
					_.isArray(_.last(decodedArguments))
				) {
					throw 'Assertion error in decoded arguments!'; // should never happen.
				}
				// Omit those two:
				decodedArguments[decodedArguments.length - 1] = _.omit(
					decodedArguments[decodedArguments.length - 1],
					'success',
					'error',
				);

				// Execute method function with arguments:
				definition = definition.apply(model, decodedArguments);

				// SPECIAL CASE #1:
				// (DAM-8470: let method functions chain multiple RPC calls)
				//
				// If an RPC method definition function returns a promise,
				// short-circuit everything else and hand that promise to triggerQuery:
				if (_.isPromise(definition)) {
					return this.triggerQuery(method, definition, [], options, model);
				}

				// SPECIAL CASE #2:
				// (DAM-8220: let method functions supress RPC calls entirely)
				//
				// If an RPC methods definition function returns false,
				// it has decided that no actual RPC call should be made.
				// In that case, hand a pre-resolved promise to _query,
				// and it will get handled the same way as in special case #1.
				//
				// (Of course a method function could do this internally,
				// and return a resolved promise -- same effect.)
				if (definition === false) {
					console.warn('RPC call suppressed by method function.'); //DEBUG -- remove before shipping ... just want to watch for a while & notice if anything's already doing this.
					// DEVNOTE:
					// I don't *think* we want to trigger the request: and complete: events here,
					// since no actual request went out.  Fake events ... just say no!
					// (But if we change our mind for some reason, replace _query with triggerQuery .)
					return this._query(
						method,
						new $.Deferred().resolve(),
						[],
						options,
						model,
					);
				}
			}

			if (!_.isArray(definition)) {
				// Not even giving you the option to override this one, since it
				// can only be a bug in an object definition & can't be fixed
				// except by writing code correctly!
				throw new Rpc.DefinitionError(
					'Bad rpc method "' + method + "'",
					definition,
				);
			}

			// check if array is deeper nested
			if (_.isArray(definition[0])) {
				deeperNested = true;
			}

			// execute a single call
			if (deeperNested !== true && _.isArray(definition)) {
				parsedParameters = _.clone(definition);
				exec = parsedParameters.shift();

				// TODO: deprecate this after 8.12.  Method functions should stop needing/expecting any further parsing of the method array they return.
				if (!hadArguments) {
					parsedParameters = this.checkParameters(
						model,
						parsedParameters,
						options,
						wasFunction,
					);
				} else {
					// DAM-5552: as of 8.10, do no further parsing of parameters returned from method signature functions that take arguments
					// console.debug('not parsing ...');//DEBUG
				}

				return this.triggerQuery(
					method,
					exec,
					parsedParameters,
					options,
					model,
				);
			}

			// Execute nested calls in parallel:
			_.each(
				definition,
				function(localdef) {
					parsedParameters = _.clone(localdef);
					exec = parsedParameters.shift();

					if (!hadArguments) {
						parsedParameters = this.checkParameters(
							model,
							parsedParameters,
							options,
							wasFunction,
						);
					} else {
						// DAM-5552: during deprecation, do no further parsing of parameters returned from method signature functions that take arguments
						// console.debug('not parsing ...');//DEBUG
					}

					// TODO: (MAYBE) In the case of these nested calls, we're not returning a promise because
					// this 'return this._query(...)' only exits the _.each loop ... so we fall through to the "return null;" below the loop.
					// Instead, we should amalgamate these promises into a super-promise using $.when().
					// (However, we're not currently using the "nested calls" feature of BRPC at all, except by accident...)
					return this.triggerQuery(
						method,
						exec,
						parsedParameters,
						options,
						model,
					);
				},
				this,
			);

			return null;
		},

		// Netx default exception handler
		defaultExceptionHandler: function(exception) {
			// NOTE: Backbone.RPC is sending custom Error subclasses here, which we could test for using instanceof.
			var sessionErrors = [6, 3001, 3002, 3003];
			if (sessionErrors.includes(exception.code)) {
				// If we have a token, some calls with give sessionErrors while others will pass.
				if (!Netx.session.getToken()) {
					// If not, a session error means our key is invalid.
					dispatcher.trigger('session:expire');
				}
				console.error(
					exception.data.call.method +
						'() API exception ' +
						exception.code +
						': ' +
						exception.message,
				);
				console.error(exception.stack); // return stack
				console.error(exception.data.call.stack); // entry stack
			} else if (exception.code === -1) {
				// TODO: https://jira.netx.net/browse/DAM-10129
				// 400 error -- URL not found
				var details = i18n.t('i18n.error400');
				if (exception.data.call.method) {
					details += '<br />' + exception.data.call.method;
				}
				dispatcher.trigger('app:alert', details);

				console.error('exception:');
				console.error(exception.stack);
			} else if (exception.code === -2) {
				// TODO: https://jira.netx.net/browse/DAM-10129
				// 500 error -- server not available
				var details = i18n.t('i18n.error500');
				if (exception.data.call.method) {
					details +=
						'<br />' +
						exception.data.call.method +
						'(): Server Not Available (Error 500)';
				}
				dispatcher.trigger('app:alert', details);

				console.error('exception:');
				console.error(exception.stack);
			} else if (exception.code === -32602) {
				// RPC Invalid Params
				// HACK, HACK, HACK, ACK, ACK, CK, K
				// https://jira.netx.net/browse/DAM-5803
				// TODO: Remove in 8.12? Shouldn't be necessary any more ....
				console.warn('server claims no API key ... '); // We should never see this ...
				if (!Netx.session.getKey()) {
					dispatcher.trigger('session:expire');
				}
			}
			// Do not spit out an error for downloads needing justification or approval
			// 4003 is for an asset bean not existing - let the controllers handle this - the asset wont exist on an upload request form!
			else if (
				exception.code !== 221 &&
				exception.code !== 220 &&
				exception.code !== 4003
			) {
				// Some other problem:
				//
				// DAM-5802: don't ever show this fairly useless error alert window.
				// if (! _.isUndefined(Netx.custom.SHOW_RPC_ALERT) && Netx.custom.SHOW_RPC_ALERT == true) {
				// 	dispatcher.trigger('app:alert', "RPC Error: " + exception.message,'Danger');
				// }

				// ... but always log to the console.
				console.error(
					exception.data.call.method +
						'() API exception ' +
						exception.code +
						': ' +
						exception.message,
				);
				console.error(exception.stack); // return stack
				console.error(exception.data.call.stack); // entry stack
			}

			//throw exception;
		},

		// Exception handler
		handleExceptions: function(error) {
			var exceptionHandler;
			if (
				error &&
				error.data &&
				error.data.call &&
				error.data.call.options &&
				error.data.call.options.exceptionHandler
			) {
				exceptionHandler = error.data.call.options.exceptionHandler; // as overridden in sync options
			} else {
				exceptionHandler = _.isFunction(this.options.exceptionHandler)
					? this.options.exceptionHandler
					: this.defaultExceptionHandler; // as specified when Rpc was instantiated
			}

			exceptionHandler.call(this, error);
			return this;
		},
	}; // Rpc.prototype

	Object.defineProperty(Rpc, 'url', {
		get function() {
			return Netx.URL.api;
		},
	});

	///////////////
	//
	// Extend RPC onto Backbone:
	//
	//
	// assign rpc to backbone itself
	Backbone.Rpc = Rpc;

	// overwrite backbones model constructor
	Backbone.Model = Backbone.Model.extend({
		constructor: function(model) {
			newConst(model, this);
			// call the original constructor
			oldModelConst.apply(this, arguments);
		},
	});

	// overwrite backbones collection constructor
	Backbone.Collection = Backbone.Collection.extend({
		// Should this take the model or the collection?
		constructor: function(model) {
			newConst(model, this);
			// call the original constructor
			oldCollectionConst.apply(this, arguments);
		},
	});

	// overwrite Backbone.sync
	// (using the anonymous function pattern to keep the internal variables private.)
	Backbone.sync = (function(Rpc) {
		// Generate a new Sync Method for JSON RPC Queuing
		var rpc = null,
			sync = function(method, model, options) {
				// skip all this RPC stuff if this model doesn't use RPC:
				if (!(model._rpc instanceof Rpc)) {
					return sync.previous.apply(model, arguments);
				}

				// define a local error callback that will hand over the data to the backbone error handler
				var errorCb = function(data) {
					options.error(model, data);
				};

				// assign the models JsonRpc instance locally
				// (closure from enclosing method)
				rpc = model._rpc;

				// First, set the api url
				rpc.url = _.isFunction(model.url) ? model.url() : model.url;

				// Second, set the namespace
				if (_.isString(model.namespace) === true) {
					rpc.namespace = model.namespace;
				}

				// go on and check the rpc methods
				// TODO: not totally sure why this 'apply' is necessary ....
				return rpc.checkMethods.apply(rpc, [model, method, options]);
			};

		// Expose the previous Backbone.sync as Backbone.sync.previous in case
		// the caller wishes to switch provider
		sync.previous = oldSync;
		return sync;
	})(Rpc);

	module.exports = Rpc;

	return Backbone;
});

/////////////////////////////////////////
// Close the module inclusion pattern: //
/////////////////////////////////////////
